export enum AppConfigurationTab {
  CONFIGURATION = 'CONFIGURATION',
}
